import React, { useCallback, useRef, useState } from 'react'
import { AdvancedSearchOptions } from 'src/Utils/search/search.types'
import { FloatingMenu } from '../../FloatingMenu/FloatingMenu'
import { FLOATING_MENU_PLACEMENT } from '../../FloatingMenu/FloatingMenu.constants'
import { PlainTooltip } from '../../Tooltip/PlainTooltip/PlainTooltip'
import { TOOLTIP_TRIGGERS, TooltipPositions } from '../../Tooltip/Tooltip'
import { AdvancedSearchButton, AdvancedSearchIcon } from '../Search.styles'
import { AdvancedSearchForm } from './AdvancedSearch.components'

export const AdvancedSearch = ({
  anchorRef,
  query,
  onSearch,
  onMouseDown,
  onOpenChange,
}: {
  anchorRef: React.RefObject<HTMLDivElement>
  query?: string
  onSearch: (
    query: string,
    advancedSearch?: AdvancedSearchOptions,
    isContentSearchActive?: boolean,
  ) => void
  onMouseDown?: React.MouseEventHandler<HTMLDivElement>
  onOpenChange?: (isOpen: boolean) => void
}): JSX.Element => {
  const menuRef = useRef<HTMLDivElement>(null)
  const buttonRef = useRef<HTMLDivElement>(null)
  const [isOpen, setIsOpen] = useState(false)

  const onClose = useCallback(() => {
    setIsOpen(false)
    onOpenChange?.(false)
  }, [onOpenChange])

  return (
    <>
      <PlainTooltip
        id="advanced-search-tooltip"
        tooltipBody={
          <p style={{ fontSize: '12px', fontWeight: '400' }}>Advanced search</p>
        }
        trigger={[TOOLTIP_TRIGGERS.HOVER, TOOLTIP_TRIGGERS.FOCUS]}
        placement={TooltipPositions.top}
        disabled={isOpen}
      >
        <AdvancedSearchButton
          onClick={(e) => {
            e.preventDefault()
            const newIsOpen = !isOpen
            setIsOpen(newIsOpen)
            onOpenChange?.(newIsOpen)
          }}
          onMouseDown={onMouseDown}
          ref={buttonRef}
        >
          <AdvancedSearchIcon />
        </AdvancedSearchButton>
      </PlainTooltip>
      {isOpen && (
        <FloatingMenu
          placement={FLOATING_MENU_PLACEMENT.BOTTOM_END}
          offsetDistance={10}
          menuRef={menuRef}
          anchorElement={anchorRef.current}
          isOpen={isOpen}
          onClose={onClose}
        >
          <AdvancedSearchForm
            onClose={onClose}
            query={query}
            onSearch={onSearch}
            show={isOpen}
            buttonRef={buttonRef}
          />
        </FloatingMenu>
      )}
    </>
  )
}
